import { AUCTION_STATUS, AUCTION_TYPES } from '@app/constants/nftMarketplace';

export const AUCTION_TYPE_OPTIONS = [
  {
    title: 'All',
    value: ''
  },
  {
    title: 'Buy it Now',
    value: AUCTION_TYPES.BUY_IT_NOW
  },
  {
    title: 'Buy it Now with bids',
    value: AUCTION_TYPES.BUY_IT_NOW_WITH_BIDS
  },
  {
    title: 'English',
    value: AUCTION_TYPES.ENGLISH_AUCTION
  }
  // {
  //   title: 'Dutch',
  //   value: AUCTION_TYPES.DUTCH_AUCTION
  // }
  // {
  //   title: 'Blind',
  //   value: AUCTION_TYPES.BLIND
  // }
];

export const AUCTION_STATUS_OPTIONS = [
  {
    title: 'All',
    value: ''
  },
  {
    title: 'Ending soon',
    value: AUCTION_STATUS.ENDING_SOON
  },
  {
    title: 'Recently sold',
    value: AUCTION_STATUS.RECENTLY_SOLD
  }
];
